<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.Query" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-button type="primary" @click="loadData">查询</el-button>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/addKnowledge',query: { callback:request } }">
                    <el-button type="primary">新建</el-button>
                </router-link>
                <el-popover
                    placement="left"
                    trigger="hover">
                    <el-tree :load="loadNode" :props="defaultProps" lazy @node-click="handleNodeClick"></el-tree>
                    <el-button slot="reference" class="rightPos">知识目录</el-button>
                </el-popover>
            </div>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column type="index" width="50"/>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="标题">
                    <template slot-scope="scope">
                        <!-- <router-link :to="{ path: '/knowledgeDetail',
                                        query: { rowData:scope.row }}"> -->
                        <router-link :to="{ path: '/knowledgeDetail',
                                        query: { KnowledgeId:scope.row.KnowledgeId,Version:scope.row.Version }}">
                            <el-button type="text">{{scope.row.Title}}</el-button>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="知识分类" prop="CategoryName"></el-table-column>
                <el-table-column label="创建人" prop="CreateUser"></el-table-column>
                <el-table-column label="知识状态">
                    <template slot-scope="scope">
                        {{ scope.row.AuditStatus | tableVal(KnowledgeStatus) }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="CreateTime"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/addKnowledge',
                                        query: { message:scope.row,type:'edit',callback:request }}">
                            <el-button type="text">修改</el-button>
                        </router-link>
                        <router-link :to="{ path: '/changeStatus',
                                        query: { message:scope.row,callback:request } }">
                            <el-button v-w-role="'ITSM-0077'" type="text">审批</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0071'" class="table-del-btn" type="text" @click="deleteRole(scope.row.KnowledgeId)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </el-card>
        
    </div>
</template>

<script>

    import services from './knowledge.service.js';
    export default {
        data: function () {
            return {
                form:{
                    Query:'',
                    CategoryId: '',
                    pageIndex:1,
                    pageSize:10
                },
                tableData:[{title:'123'}],
                total:5,
                defaultProps: {
                    label: 'title',
                    isLeaf: 'hasChildren',
                },
                loading:true,
                list:[
                    { id:"297",name:"用户创建"},
                    { id:"299",name:"事件管理"},
                    { id:"301",name:"问题管理"},
                    { id:"303",name:"变更管理"},
                    { id:"305",name:"发布管理"},
                    { id:"307",name:"其他网站"},
                ],
                dialogFormVisible: false,
                formLabelWidth: '120px',
                dataListArray:''
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 知识状态
            KnowledgeStatus(){
                return this.dictionary.KnowledgeAuditStatus;
            },
        },
        created(){
            this.request();
        },
        methods:{
            loadData(){
                this.form.pageIndex=1
                this.request()
            },
            request(){//获取目录列表
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                if(this.form.Query){
                    services.knowledgeQuery(this.form).then(res=>{
                        this.tableData = res.KnowledgeTable;
                        this.total = res.total;
                    }).catch(err => {
                        this.$message.error(err.message);
                    }).finally(() => {
                        this.loading = false;
                    })
                }else{
                    services.knowledgeList(this.form).then(res=>{
                        this.tableData = res.KnowledgeTable;
                        this.total = res.total;
                    }).catch(err => {
                        this.$message.error(err.message);
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            },
            loadNode(node, resolve) {//加载目录列表
                if (node.level === 0) {//加载最外层的目录
                    services.getSortListMes({"type":'15'}).then(res => {
                        res.forEach(item => {
                            item.hasChildren = !item.hasChildren;
                        });
                        if(res[0]){
                            return resolve(res);
                        }else{
                            return resolve([]);
                        }
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }else{//加载下级目录
                    services.getChildSortListMes({"parentId":node.data.id}).then(res => {
                        res.forEach(item => {
                            item.hasChildren = !item.hasChildren;
                        });
                        if(res[0]){
                            return resolve(res);
                        }else{
                            return resolve([]);
                        }
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }
            },
            handleNodeClick(data){//根据目录id查找知识列表
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                let param = {
                    "CategoryId":data.id,
                    "pageIndex":this.form.pageIndex,
                    "pageSize":this.form.pageSize
                }
                services.knowledgeList(param).then(res => {
                    this.tableData = res.KnowledgeTable;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            deleteRole(id){//删除目录信息
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.knowledgeDel({"KnowledgeId":id}).then(res => {
                        this.$message.success("成功删除!");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request();
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rightPos{
        position: absolute;
        right: 50px;
        width: 100px;
    }
    .scrollTitle{
        background: red !important;
    }
</style>
